export type ApiErrorBody = {
  code: number;
  message: string;
  type: string;
};

export class ApiError extends Error {
  readonly code: number;
  readonly type: string;
  readonly httpStatus: number;

  private constructor(body: ApiErrorBody, httpStatus: number) {
    super(body.message);
    this.name = "ApiError";
    this.code = body.code;
    this.type = body.type;
    this.httpStatus = httpStatus;
  }

  static async fromResponse(response: Response): Promise<ApiError> {
    try {
      const body = await response.json();
      if (typeof body?.code === "number") {
        return new ApiError(body, response.status);
      }
    } catch {
      // réponse non-JSON (ex: erreur brute d'un proxy)
    }

    return new ApiError(
      {
        code: 0,
        type: "UnknownException",
        message: `HTTP ${response.status}`,
      },
      response.status,
    );
  }
}
